import { call, put, takeLatest } from "redux-saga/effects";
import {
  GeneralUtilsAction,
  InitAction,
  PettyCashierHashtagDetailReportAction
} from "../../../actions";
import * as types from "../../../actions/actionTypes";
import moment from "jalali-moment";
import * as hashtagDetailReportApi from "../../../api/hashtagReport/detail/pettyCashierHashtagDetailReport";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../../../assets/checkErrorMessagesExist";
import { GetFilterDetail } from "../../../hocs/hashtagsReport/components/filter/tools";
import { PAYMENT, RECEIVE } from "../../../constants/accountReviewTypes";
import * as paymentApi from "../../../api/payment/pettyCashierPayment";
import * as receiveApi from "../../../api/receive/pettyCashierReceive";
import { createBrowserHistory } from "history";
import { PAGE_NUM } from "../../../constants/filters";
moment.locale("fa");
export function* pettyCashierWatcherHashtagDetailReport() {
  yield takeLatest(
    types.PETTY_CASHIER_GET_HASHTAG_DETAIL_REVIEW_REQUEST,
    worker
  );
  yield takeLatest(
    types.PETTY_CASHIER_REMOVE_HASHTAG_DETAIL_REVIEW_REQUEST,
    remove
  );
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";

  return hashtagDetailReportApi.getList(page_number, GetFilterDetail());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(PettyCashierHashtagDetailReportAction.getSuccess(response.data));
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });

    yield put(PettyCashierHashtagDetailReportAction.getFailure(error));
  }
}

async function removeRequest(id, account_type) {
  if (account_type === PAYMENT) {
    return paymentApi.remove(id);
  } else if (account_type === RECEIVE) {
    return receiveApi.remove(id);
  }
}

function* remove(action) {
  try {
    const response = yield call(removeRequest, action.id, action.account_type);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const responseReq = yield call(fetchList, action.pageNumber);
    const history = createBrowserHistory();
    const urlParams = new URLSearchParams(window.location.search);
    const pNum = urlParams.get(PAGE_NUM);
    if (pNum !== action.pageNumber) {
      urlParams.set(PAGE_NUM, action.pageNumber);
      history.push({ search: urlParams.toString() });
    }
    yield put(
      PettyCashierHashtagDetailReportAction.removeSuccess(responseReq.data)
    );
    yield put(GeneralUtilsAction.closeConfirmForTable());
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PettyCashierHashtagDetailReportAction.removeFailure(error));
  }
}
